import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { SubvensionService } from 'app/services/subvension.service';
import { Subvension } from 'app/model/subvension';
import { AuthService } from 'app/services/auth.service';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { isHK } from 'app/app.component';

@Component({
  selector: 'app-subvensions-editor',
  templateUrl: './subvensions-editor.component.html',
  styleUrls: ['./subvensions-editor.component.css']
})

export class SubvensionsEditorComponent implements OnInit {

  @Input() model: Subvension;
  su = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private subvensionService: SubvensionService,
    private authService: AuthService,
    private location: Location) { }

  ngOnInit() {
    this.su = this.authService.isSuperUser();
    this.getModel();
  }

  getIsHK(): boolean {
    return isHK;
  }

  getModel(): void {
    const id = this.route.snapshot.paramMap.get('id');
    if (id) {
      this.subvensionService.getSubvension(id)
        .subscribe(subv => this.model = subv);
    } else {
      this.model = new Subvension();
      this.model.warunki = '';
      this.model.nazwa = '';
      this.model.info = '';
      this.model.doplata_procent = 0;
      this.model.kredyt_procent = 0;
      this.model.okres = 0;
    }
  }

  save() {
    if (this.model.nazwa) {
      this.subvensionService.save(this.model);
      this.model = new Subvension();
      this.router.navigate(['/subvensions']);
    }
  }

  newSubvension(): void {
    this.model = new Subvension();
  }

  isSuperUser() {
    return this.su;
  }

  cancel() {
    this.subvensionService.reloadFromDb();
    this.model = new Subvension();
    this.router.navigate(['/subvensions']);
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/subvensions-editor/subvensions-editor.component.ts